import { status } from "skin/event/status";
import cli from "./cli";
import { _multy, _value } from "./fn";

const msSelectModAdm = (obj, ms, story, data, d, action) => {
	const code = JSON.parse(d).code;
	const multy = data.curData.values.fld.multy;
	if (code === "msSelectModCli") cli(obj, ms, story, data, d, action, code);

	if (obj.action === "next" && multy === false) {
		data.setValue("value", 1);
		return status.action;
	}

	switch (obj.name) {
		case "multy":
			return _multy(obj, data);
		case "value":
			return _value(multy);
		default:
			return status.action;
	}
};

// Старая редакция в архиве. Kaor00
export default msSelectModAdm;
